const VolumePercentageRules = [
  {
    required: true,
    message: "Por favor introduce el porcentaje de nivel actual del tanque.",
  },
  {
    type: "number" as const,
    min: 0,
    max: 100,
    message: "El porcentaje debe estar entre 0 y 100",
  },
];

const VolumeLitersRules = [
  { required: true, message: "Por favor introduce el volumen en litros." },
  {
    type: "number" as const,
    min: 0,
    message: "El volumen no puede ser negativo",
  },
];

const ContainerRules = [
  {
    required: true,
    message: "Seleccione el contenedor al que se le agregará un registro",
  },
];

const DateRules = [
  { required: true, message: "Por favor introduce la fecha de la medición." },
];

const TemperatureRules = [
  {
    required: true,
    message: "Por favor introduce la temperatura actual del tanque.",
  },
];

const PressureRules = [
  {
    required: true,
    message: "Por favor introduce la presión actual del tanque.",
  },
];

export default {
  VolumePercentageRules,
  VolumeLitersRules,
  ContainerRules,
  DateRules,
  TemperatureRules,
  PressureRules,
};
